export const VALUE = 'VALUE';
export const UPDATED_AT = 'UPDATED_AT';
export const VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION = 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION';
export const ANNIVERSARY = 'ANNIVERSARY';
export const ANNIVERSARY_WITH_ZONE_SAME_LOCAL_CONVERSION = 'ANNIVERSARY_WITH_ZONE_SAME_LOCAL_CONVERSION';